var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0078FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,14.3c-0.4-0.4-1-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,1,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5C29.5,15.2,29.3,14.7,28.9,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,15.8c0-0.7-0.3-1.4-0.8-2c-0.5-0.5-1.3-0.8-2-0.8s-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2 c0,0.7,0.3,1.4,0.8,2c0.5,0.5,1.3,0.8,2,0.8s1.5-0.3,2-0.8C5.9,17.2,6.2,16.5,6.2,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,25.3c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.6,1.5,0.6 c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5C16.5,25.5,15.9,25.3,15.3,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,0.5c-1,0-1.9,0.4-2.6,1.1c-0.7,0.7-1.1,1.6-1.1,2.6c0,0.9,0.4,1.9,1.1,2.6c0.7,0.7,1.7,1.1,2.6,1.1 c1,0,1.9-0.4,2.6-1.1c0.7-0.7,1.1-1.6,1.1-2.6c0-0.9-0.4-1.9-1.1-2.6C17.3,0.9,16.3,0.5,15.3,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,21.9c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.6,1.5,0.6 c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5C25,22.1,24.4,21.9,23.8,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,4.4C6,4.4,5.2,4.7,4.6,5.3c-0.6,0.6-1,1.4-1,2.2c0,0.8,0.4,1.6,1,2.2c0.6,0.6,1.4,0.9,2.3,0.9 s1.7-0.3,2.3-0.9c0.6-0.6,1-1.4,1-2.2c0-0.8-0.4-1.6-1-2.2C8.6,4.7,7.7,4.4,6.9,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,21.9c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.6,1.5,0.6 c0.6,0,1.1-0.2,1.5-0.6C8.8,25.1,9,24.5,9,24c0-0.6-0.2-1.1-0.6-1.5C8,22.1,7.4,21.9,6.9,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,9.6c0.6,0,1.1-0.2,1.5-0.6C25.8,8.6,26,8.1,26,7.5C26,7,25.8,6.4,25.4,6c-0.4-0.4-1-0.6-1.5-0.6 c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5C22.7,9.4,23.3,9.6,23.8,9.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.9c6e8a34.svg";
export { ForwardRef as ReactComponent };